module.exports = __webpack_public_path__ + "static/frontUserNew/img/door-video-default.fd1b2e18.png";